// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_STITCHING_DC_REQUEST = 'FETCH_STITCHING_DC_REQUEST';
export const FETCH_STITCHING_DC_SUCCESS = 'FETCH_STITCHING_DC_SUCCESS';
export const FETCH_STITCHING_DC_FAILURE = 'FETCH_STITCHING_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_YARN_PO_IN_STITCHING_DC_REQUEST = 'FETCH_YARN_PO_IN_STITCHING_DC_REQUEST';
export const FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS = 'FETCH_YARN_PO_IN_STITCHING_DC_SUCCESS';
export const FETCH_YARN_PO_IN_STITCHING_DC_FAILURE = 'FETCH_YARN_PO_IN_STITCHING_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_STITCHING_DC_REQUEST = 'CREATE_STITCHING_DC_REQUEST';
export const CREATE_STITCHING_DC_SUCCESS = 'CREATE_STITCHING_DC_SUCCESS';
export const CREATE_STITCHING_DC_FAILURE = 'CREATE_STITCHING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_STITCHING_DC = 'CREATE_USER_FORM_STITCHING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_STITCHING_DC_REQUEST = 'UPDATE_STITCHING_DC_REQUEST';
export const UPDATE_STITCHING_DC_SUCCESS = 'UPDATE_STITCHING_DC_SUCCESS';
export const UPDATE_STITCHING_DC_FAILURE = 'UPDATE_STITCHING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_STITCHING_DC_REQUEST = 'FETCH_SINGLE_STITCHING_DC_REQUEST';
export const FETCH_SINGLE_STITCHING_DC_SUCCESS = 'FETCH_SINGLE_STITCHING_DC_SUCCESS';
export const FETCH_SINGLE_STITCHING_DC_FAILURE = 'FETCH_SINGLE_STITCHING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_STITCHING_DC_REQUEST = 'DELETE_STITCHING_DC_REQUEST';
export const DELETE_STITCHING_DC_SUCCESS = 'DELETE_STITCHING_DC_SUCCESS';
export const DELETE_STITCHING_DC_FAILURE = 'DELETE_STITCHING_DC_FAILURE';

// USERFORM RESET

export const STITCHING_DC_USERFORM_RESET = 'STITCHING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_STITCHING_DC_DETAILS = 'NAVIGATE_STITCHING_DC_DETAILS';

// navigate to company component
export const NAVIGATE_STITCHING_DC = 'NAVIGATE_STITCHING_DC';
export const STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'STITCHING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_STITCHING_DC_INVOICE_REQUEST = 'FETCH_STITCHING_DC_INVOICE_REQUEST';
export const FETCH_STITCHING_DC_INVOICE_SUCCESS = 'FETCH_STITCHING_DC_INVOICE_SUCCESS';
export const FETCH_STITCHING_DC_INVOICE_FAILURE = 'FETCH_STITCHING_DC_INVOICE_FAILURE';

export const FETCH_STITCHING_DC_ACCESSORIES_REQUEST = 'FETCH_STITCHING_DC_ACCESSORIES_REQUEST';
export const FETCH_STITCHING_DC_ACCESSORIES_SUCCESS = 'FETCH_STITCHING_DC_ACCESSORIES_SUCCESS';
export const FETCH_STITCHING_DC_ACCESSORIES_FAILURE = 'FETCH_STITCHING_DC_ACCESSORIES_FAILURE';

export const FETCH_STITCHING_DC_BARCODE_REQUEST = 'FETCH_STITCHING_DC_BARCODE_REQUEST';
export const FETCH_STITCHING_DC_BARCODE_SUCCESS = 'FETCH_STITCHING_DC_BARCODE_SUCCESS';
export const FETCH_STITCHING_DC_BARCODE_FAILURE = 'FETCH_STITCHING_DC_BARCODE_FAILURE';

export const FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST = 'FETCH_STITCHING_DC_PRINT_BARCODE_REQUEST';
export const FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS = 'FETCH_STITCHING_DC_PRINT_BARCODE_SUCCESS';
export const FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE = 'FETCH_STITCHING_DC_PRINT_BARCODE_FAILURE';


export const RESET_STITCHING_DC_INVOICE = 'RESET_STITCHING_DC_INVOICE';

export const NAVIGATE_STITCHING_WITH_ACC = 'NAVIGATE_STITCHING_WITH_ACC'
export const NAVIGATE_STITCHING_WITH_ACC_LAST = 'NAVIGATE_STITCHING_WITH_ACC_LAST'
export const NAVIGATE_STITCHING_WITH_ACC_INITIAL = 'NAVIGATE_STITCHING_WITH_ACC_INITIAL'

export const NAVIGATE_STITCHING_WITH_DELIVERY_NOTE = 'NAVIGATE_STITCHING_WITH_DELIVERY_NOTE'


export const UNIT_ID_WITH_PREV_CONSTANT_VALUE = 'UNIT_ID_WITH_PREV_CONSTANT_VALUE'




export const STITCHING_SUPPLIER_UPDATE_REQUEST = 'STITCHING_SUPPLIER_UPDATE_REQUEST'
export const STITCHING_SUPPLIER_UPDATE_SUCCESS = 'STITCHING_SUPPLIER_UPDATE_SUCCESS'
export const STITCHING_SUPPLIER_UPDATE_FAILURE = 'STITCHING_SUPPLIER_UPDATE_FAILURE'


export const RESET_STITCHING_ACC_PRINT = 'RESET_STITCHING_ACC_PRINT'

export const RESET_BARCODE_DC_INVOICE = 'RESET_BARCODE_DC_INVOICE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD'

export const NAVIGATE_STITCHING_DC_PRINT = 'NAVIGATE_STITCHING_DC_PRINT';

export const RESET_FOLDING_FABRIC_PRINT = 'RESET_FOLDING_FABRIC_PRINT'

export const FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST = 'FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_REQUEST';
export const FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS = 'FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_SUCCESS';
export const FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE = 'FETCH_FOLDING_FABRIC_IN_STITCHING_DC_PRINT_FAILURE';



// All Reports for Stitching DC

export const FETCH_IN_STITCHING_DC_REPORTS_REQUEST = 'FETCH_IN_STITCHING_DC_REPORTS_REQUEST';
export const FETCH_IN_STITCHING_DC_REPORTS_SUCCESS = 'FETCH_IN_STITCHING_DC_REPORTS_SUCCESS';
export const FETCH_IN_STITCHING_DC_REPORTS_FAILURE = 'FETCH_IN_STITCHING_DC_REPORTS_FAILURE';

export const RESET_STITCHING_DC_REPORTS = 'RESET_STITCHING_DC_REPORTS';


export const FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST = 'FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_REQUEST';
export const FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS = 'FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_SUCCESS';
export const FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE = 'FETCH_IN_STITCHING_DC_REPORTS_PRODUCTION_FAILURE';


export const UPDATE_ACTION_IN_STITCHING_DC_REPORTS = 'UPDATE_ACTION_IN_STITCHING_DC_REPORTS';


